import type { MessageDictionary } from '../types';

export const zhCNMessages: Partial<MessageDictionary> = {
  'i18n.languageSwitcher.label': '语言',
  'i18n.languageSwitcher.english': 'English',
  'i18n.languageSwitcher.simplifiedChinese': '简体中文',
  'i18n.languageSwitcher.traditionalChinese': '繁体中文',
  'nav.home': '首页',
  'nav.allTutors': '所有导师',
  'nav.allCases': '所有个案',
  'nav.becomeTutor': '成为导师',
  'nav.aboutUs': '关于我们',
  'nav.support': '支援',
  'nav.howItWorks': '运作方式',
  'nav.helpCenter': '帮助中心',
  'nav.tuitionFeeReference': '学费参考',
  'nav.findTutor': '寻找导师',
  'nav.registerTutor': '注册成为导师',
  'nav.login': '登入',
  'nav.myCases': '我的个案',
  'nav.myLikedTutors': '我收藏的导师',
  'nav.editProfile': '编辑个人资料',
  'nav.completeProfile': '完成个人资料',
  'nav.uploadDocuments': '上传文件',
  'nav.myApplications': '我的申请',
  'nav.logout': '登出',
  'nav.userFallback': '用户',
  'nav.pendingVerification': '审核中',
  'nav.verified': '已验证',
  'nav.approved': '已批准',
  'nav.rejected': '已拒绝',
  'nav.musicPromo.mobile': '音乐导师即将推出',
  'nav.musicPromo.desktop': '音乐导师即将推出。立即加入候补名单，抢先获得最新消息。',
  'nav.musicPromo.join': '加入',
  'nav.musicPromo.joinWaitlist': '加入候补名单',
  'nav.musicPromo.dismiss': '关闭音乐导师候补宣传',
  'footer.tagline': '连结热爱教学的导师与马来西亚各地积极学习的学生。',
  'footer.quickLinks': '快速连结',
  'footer.findTutors': '寻找导师',
  'footer.company': '公司资讯',
  'footer.termsCustomers': '条款 - 家长',
  'footer.termsTutors': '条款 - 导师',
  'footer.privacyPolicy': '私隐政策',
  'footer.contactUs': '联络我们',
  'footer.location': '马来西亚吉隆坡',
  'footer.copyright':
    '© 2026 Glowston Tech（商业注册号码 202503300880）。版权所有。',
  'notFound.description': '你正在寻找的页面不存在。',
  'whatsapp.defaultMessage': '你好！我想了解更多 Tutor Founder 的资讯。',
  'whatsapp.ariaLabel': '透过 WhatsApp 联络我们',
  'whatsapp.title': '在 WhatsApp 与我们聊天',
  'aiMatch.title': 'AI 配对',
  'aiMatch.subtitle': '请先选择你的身份以继续',
  'aiMatch.tutor.title': '我是导师',
  'aiMatch.tutor.description': '注册并开始提供补习服务',
  'aiMatch.parent.title': '我是家长／学生',
  'aiMatch.parent.description': '发布个案以寻找合适导师',
  'howItWorks.hero.title': '运作方式',
  'howItWorks.hero.description':
    '无论你是想为孩子寻找优质补习的家长，还是想增加收入的导师，我们都把流程设计得清晰、公平又快速。',
  'howItWorks.tab.parents': '给家长',
  'howItWorks.tab.tutors': '给导师',
  'howItWorks.journey.eyebrow': '流程一览',
  'howItWorks.journey.parent.title': '从第一次点击到第一堂课',
  'howItWorks.journey.parent.description': '五个简单步骤。没有意外、没有繁琐文件，只有高品质补习配对。',
  'howItWorks.journey.tutor.title': '从注册到收款',
  'howItWorks.journey.tutor.description': '五个清楚步骤，成为已验证并可正式接案的 Tutor Founder 导师。',
  'howItWorks.cta.tutor.title': '准备开始教学了吗？',
  'howItWorks.cta.tutor.description': '加入我们的认证导师社群，把你的教学能力转化成稳定收入。',
  'howItWorks.cta.tutor.button': '开始注册',
  'howItWorks.cta.parent.title': '准备好找到你的导师了吗？',
  'howItWorks.cta.parent.description': '使用我们的 AI 配对系统，在几秒内找到最适合的导师。',
  'howItWorks.cta.parent.button': '发布你的第一个个案',
  'processFlow.parent.step1.tag': '告诉我们',
  'processFlow.parent.step1.title': '发布你的个案',
  'processFlow.parent.step1.description':
    '填写科目、程度、地点和时间。简短表单即可开始，不必先注册也能先了解流程。',
  'processFlow.parent.step1.meta': '大约 2 分钟完成',
  'processFlow.parent.step2.tag': '我们配对',
  'processFlow.parent.step2.title': '取得合适导师名单',
  'processFlow.parent.step2.description':
    '我们会为你筛选 2-3 位符合科目、地点、时间和预算的已验证导师。不用盲找，也不用到处联络。',
  'processFlow.parent.step2.meta': '24 小时内',
  'processFlow.parent.step3.tag': '你选择',
  'processFlow.parent.step3.title': '查看并挑选导师',
  'processFlow.parent.step3.description':
    '浏览导师的个人档案、学历、评价和经验，自由选择最适合你的一位，没有压力。',
  'processFlow.parent.step3.meta': '决定权始终在你手上',
  'processFlow.parent.step4.tag': '安全付款',
  'processFlow.parent.step4.title': '安全付款，先付 1 个月',
  'processFlow.parent.step4.description':
    '你的付款会安全存放于第三方保管机制中，只有课堂完成后才会拨给导师。支援银行转帐及 TNG。',
  'processFlow.parent.step4.meta': '款项安全托管',
  'processFlow.parent.step5.tag': '开始学习',
  'processFlow.parent.step5.title': '开始第一堂课',
  'processFlow.parent.step5.description':
    '每周课堂正式开始。你可直接与导师沟通安排；若不合适，也可更换导师或为未使用课堂申请退款。',
  'processFlow.parent.step5.meta': '可随时转换',
  'processFlow.tutor.step1.tag': '注册',
  'processFlow.tutor.step1.title': '建立你的个人档案',
  'processFlow.tutor.step1.description':
    '加入你教授的科目、程度、地区和收费，设定时间表与授课模式（线上、面授或两者皆可）。',
  'processFlow.tutor.step1.meta': '大约 5 分钟完成',
  'processFlow.tutor.step2.tag': '验证',
  'processFlow.tutor.step2.title': '完成验证',
  'processFlow.tutor.step2.description':
    '提交补充文件或证书供审核，并加入身份证件以在通过后取得 Verified 标记资格。',
  'processFlow.tutor.step2.meta': '2-3 个工作天',
  'processFlow.tutor.step3.tag': '收到配对',
  'processFlow.tutor.step3.title': '接收个案通知',
  'processFlow.tutor.step3.description':
    '当家长发布与你资料匹配的个案时，你会透过电邮与 WhatsApp 收到通知，可自由选择接受或略过。',
  'processFlow.tutor.step3.meta': '透过电邮与 WhatsApp',
  'processFlow.tutor.step4.tag': '开始教学',
  'processFlow.tutor.step4.title': '每周授课',
  'processFlow.tutor.step4.description':
    '你可自行设定时间和收费，进行线上或面授课堂，并直接与家长协调，不会有平台介入你的教学。',
  'processFlow.tutor.step4.meta': '线上或面授皆可',
  'processFlow.tutor.step5.tag': '收款',
  'processFlow.tutor.step5.title': '每月拨款到你的银行户口',
  'processFlow.tutor.step5.description':
    '每个月月底自动转帐。第 1-2 个月你收取 75%，第 3 个月起为 100%。佣金按每个新个案独立计算，不是按导师计算。',
  'processFlow.tutor.step5.meta': '每月月底自动转帐',
  'processFlow.svg.parent.case': '发布个案',
  'processFlow.svg.parent.subject': '科目',
  'processFlow.svg.parent.location': '地点',
  'processFlow.svg.parent.submit': '提交 ->',
  'processFlow.svg.parent.matches': '2 位配对导师',
  'processFlow.svg.parent.name': '陈慧玲',
  'processFlow.svg.parent.profile': '数学学士 · 马来亚大学',
  'processFlow.svg.parent.rating': '4.9 · 127 堂课',
  'processFlow.svg.parent.subject.math': '数学',
  'processFlow.svg.parent.subject.addMath': '高等数学',
  'processFlow.svg.parent.choose': '选择 ->',
  'processFlow.svg.parent.bankTransfer': '银行转帐',
  'processFlow.svg.parent.tng': 'TNG',
  'processFlow.svg.tutor.subject.math': '数学',
  'processFlow.svg.tutor.subject.physics': '物理',
  'processFlow.svg.tutor.rate': 'RM 80/小时',
  'processFlow.svg.tutor.identityDocument': '身份证明文件',
  'processFlow.svg.tutor.accept': '接受',
  'processFlow.svg.tutor.pass': '略过',
  'processFlow.svg.tutor.equation': 'f(x) = 2x² + 3x',
  'processFlow.svg.tutor.monthlyPayout': '每月拨款',
  'processFlow.svg.tutor.net': '实收（第 3 个月起，单一个案）',
  'helpCenter.hero.title': '帮助中心',
  'helpCenter.hero.description': '在这里找到常见问题答案和你需要的支援',
  'helpCenter.tab.common': '常见问题',
  'helpCenter.tab.tutor': '给导师',
  'helpCenter.tab.parent': '给家长／学生',
  'helpCenter.section.common': '常见问题',
  'helpCenter.section.tutor': '导师常见问题',
  'helpCenter.section.parent': '家长与学生常见问题',
  'helpCenter.contact.title': '还需要帮忙吗？',
  'helpCenter.contact.description': '如果找不到你想要的答案，我们的支援团队随时为你提供协助。',
  'helpCenter.contact.email': '电邮联络',
  'helpCenter.contact.whatsapp': 'WhatsApp 联络我们',
  'helpCenter.common.1.question': '如何建立帐户？',
  'helpCenter.common.1.answer':
    '你可以点击导航列中的「登入／注册」按钮建立帐户。你可使用电邮、电话号码或社交帐户（Google）进行注册。',
  'helpCenter.common.2.question': '使用 Tutor Founder 是否免费？',
  'helpCenter.common.2.answer':
    '是的，建立帐户以及浏览导师或课程完全免费。我们不向学生或家长收取平台费用，导师也可以免费注册和刊登服务。',
  'helpCenter.common.3.question': '付款流程是怎样的？',
  'helpCenter.common.3.answer':
    '家长／学生在预约课堂时会向 Tutor Founder 平台付款。Tutor Founder 会安全保管款项，并在每月月底向导师发放款项。这样可让家长付款更简单，也让导师有稳定的每月拨款安排。详情请参阅服务条款与付款页面，了解收费、拨款时段及争议处理流程。',
  'helpCenter.common.4.question': '平台是否安全可靠？',
  'helpCenter.common.4.answer':
    '是的。Tutor Founder 采用业界标准安全措施保护你的资料与付款资讯。我们会加密敏感资料、限制个人资料存取权限，并与可信赖的支付服务商合作。完整资料可参阅私隐与安全政策。',
  'helpCenter.common.5.question': '如果导师停止教学怎么办？',
  'helpCenter.common.5.answer':
    '如果导师停止教学或无法继续，Tutor Founder 会协助受影响的家长。我们可视情况安排未使用课堂退款或协助重新配对导师。退款与争议处理会按照我们的退款与争议政策进行，如需协助请联络客服。',
  'helpCenter.common.6.question': '我可以取消或改期课堂吗？',
  'helpCenter.common.6.answer':
    '可以，你可以直接与导师沟通取消或改期。我们建议在开始补习前先和导师订立清晰的取消政策。',
  'helpCenter.common.7.question': 'Tutor Founder 覆盖哪些地区？',
  'helpCenter.common.7.answer':
    'Tutor Founder 覆盖马来西亚各主要城市和州属。我们同时提供面授及线上补习导师，让更多学生能接触优质教育资源。',
  'helpCenter.tutor.1.question': '如何成为已验证导师？',
  'helpCenter.tutor.1.answer':
    '要成为已验证导师，请完成导师注册流程并上传身份证明文件（身分证、护照或驾照）。我们的团队会在 2-3 个工作天内审核你的申请和资料。',
  'helpCenter.tutor.2.question': '成为导师需要什么资格？',
  'helpCenter.tutor.2.answer':
    '我们欢迎不同学历背景的导师，但建议至少具备 SPM 或同等学历。若有 STPM、文凭或学士等更高学历会更具优势。教学经验与科目专长亦是重要因素。',
  'helpCenter.tutor.3.question': '如何设定我的补习收费？',
  'helpCenter.tutor.3.answer':
    '你可以根据自己的学历、经验和教授科目自行设定每小时收费。我们也提供学费参考指南，帮助你更具竞争力地定价。你可随时在个人档案设定中调整收费。',
  'helpCenter.tutor.4.question': '我会如何收到个案通知？',
  'helpCenter.tutor.4.answer':
    '完成注册并通过验证后，当有符合你档案的新课堂／个案时，你会透过电邮和 WhatsApp 收到通知。你也可以在帐户设定中调整通知偏好。',
  'helpCenter.tutor.5.question': '我可以同时教线上和面授课吗？',
  'helpCenter.tutor.5.answer':
    '可以。你可在个人档案中设定偏好的授课模式（面授、线上或两者皆可），从而获得更大的灵活度及更多潜在学生。',
  'helpCenter.tutor.6.question': '如果和学生出现问题，我应该怎么做？',
  'helpCenter.tutor.6.answer':
    '如果遇到任何问题，我们建议先和学生或家长坦诚沟通。若问题持续，请透过帮助中心联络支援团队，或电邮至 tutorfounder@gmail.com。',
  'helpCenter.parent.1.question': '如何为孩子找到合适的导师？',
  'helpCenter.parent.1.answer':
    '你可以透过科目、地点、经验和价格等筛选条件浏览导师名单。你也可使用 AI 配对系统，提交需求后由我们为你配对合适导师。',
  'helpCenter.parent.2.question': '所有导师都有背景审核吗？',
  'helpCenter.parent.2.answer':
    '所有带有「Verified」标记的导师都已提交身份证明文件并由我们完成核实。不过，我们仍建议你在开始课堂前自行面谈并查询推荐资料。',
  'helpCenter.parent.3.question': '如果我对导师不满意怎么办？',
  'helpCenter.parent.3.answer':
    '如果你对导师不满意，可以随时寻找并更换另一位导师，没有绑约或长期承诺。我们也欢迎你提供意见，帮助平台持续改善。',
  'helpCenter.parent.4.question': '如何发布补习个案？',
  'helpCenter.parent.4.answer':
    '点击导航列中的「AI 配对」，选择「我是家长／学生」，然后填写你的补习需求，包括科目、程度、地点和上课时间偏好。提交后，合适导师就会收到通知。',
  'helpCenter.parent.5.question': '我可以为不同科目聘请多位导师吗？',
  'helpCenter.parent.5.answer':
    '当然可以。你可以为不同科目发布多个课堂／个案，并同时与多位导师接洽。每个课堂都会独立处理。',
  'earnings.badge.mostCommon': '最常见',
  'earnings.label.hoursPerWeek': '每周时数',
  'earnings.label.hourlyRate': '每小时收费',
  'earnings.label.grossMonthly': '每月总收入',
  'earnings.label.yourNet': '你的实收',
  'earnings.footnote.label': '提醒：',
  'earnings.footnote.text': '第 2 个月后平台费会降至 0%，你可保留每月总收入的 100%。',
  'earnings.scenario.jason.description': '中五数学',
  'earnings.scenario.sarah.description': '小学英文',
  'earnings.scenario.ahmad.description': 'A-Level 物理',
  'howItWorksFaq.tutor.1.question': '如何设定我的时薪？',
  'howItWorksFaq.tutor.1.answer':
    '你可根据自己的学历、经验及教授科目自行设定收费。我们会提供学费参考指南，协助你制定具竞争力的价格。你也可随时在个人档案设定中调整收费。平台不会从你设定的时薪中再额外扣费，你可直接与家长协调。',
  'howItWorksFaq.tutor.2.question': '我到底什么时候会收到款项？',
  'howItWorksFaq.tutor.2.answer':
    '我们会先向家长收取款项（预付 1 个月课堂费用），而你会在每月月底透过自动转帐收到应得款项。个案第 1-2 个月你会收到 75%（我们收取 25% 佣金），第 3 个月起则可收到 100%。一般 2-3 个工作天内会入帐。',
  'howItWorksFaq.tutor.3.question': '首两个月的 25% 佣金是什么？',
  'howItWorksFaq.tutor.3.answer':
    '平台佣金只适用于每个个案的首两个月，用来支援配对、验证和资金托管服务。由第 3 个月起，该个案便不再抽佣，你可保留 100% 收入。佣金结构会按每个个案独立重新计算，所以之后接新个案时，新个案的首两个月同样会有 25% 佣金。',
  'howItWorksFaq.tutor.4.question': '如果家长取消怎么办？',
  'howItWorksFaq.tutor.4.answer':
    '如果家长在课堂开始前或进行初期取消，你可能会按当月已进行的比例收到部分款项。若你需要取消课堂，请直接通知家长并安排补课。过度取消可能影响你的个人档案评级，详情请参阅完整取消政策与条款。',
  'howItWorksFaq.tutor.5.question': '我如何和家长配对？',
  'howItWorksFaq.tutor.5.answer':
    '完成验证后，你会自动出现在导师名录和 AI 配对系统中。当家长发布与你档案相符的个案（科目、地点、时间、收费）时，我们会透过电邮和 WhatsApp 通知你。你可以自由接受或拒绝，没有强制。个案越多，收入潜力越高。',
  'howItWorksFaq.tutor.6.question': '我可以同时教线上和面授吗？',
  'howItWorksFaq.tutor.6.answer':
    '当然可以。你可在个人档案中设定偏好的授课模式（线上、面授或两者皆可），甚至可同一科目对不同家长采用不同模式。灵活度越高，越容易吸引更多个案。',
  'howItWorksFaq.tutor.7.question': '如果出现付款争议怎么办？',
  'howItWorksFaq.tutor.7.answer':
    '如果你觉得月底拨款有问题（例如金额计算错误或款项遗漏），可在拨款后 7 天内提出争议。请联络支援团队并提供详情，我们会在 7 个工作天内调查和处理。我们的托管系统会同时保障你和家长。',
  'howItWorksFaq.tutor.8.question': '我可以同时教多个个案吗？',
  'howItWorksFaq.tutor.8.answer':
    '可以。很多导师都会同时教授多个来自不同家长的个案。每个个案都是独立的，例如你可以为一个家庭教数学，为另一个家庭教英文。个案越多，每月收入越高，但也要确保自己能妥善管理时间表。',
  'howItWorksFaq.parent.1.question': '找导师要花多少钱？',
  'howItWorksFaq.parent.1.answer':
    '浏览导师和发布个案完全免费。只有当你决定预约某位导师的课堂时才需要付款。价格会视导师专长和科目而有所不同，你可参考我们的学费指南了解不同教育程度的常见收费。',
  'howItWorksFaq.parent.2.question': '如何发布个案？',
  'howItWorksFaq.parent.2.answer':
    '点击导航中的「AI 配对」，选择「我是家长／学生」，然后填写科目、程度、地点、上课时间和预算等资料，大约 2 分钟即可完成。提交后，我们的 AI 会在 24 小时内为你配对 2-3 位合适导师。',
  'howItWorksFaq.parent.3.question': '预约后我的款项会怎样处理？',
  'howItWorksFaq.parent.3.answer':
    '你的付款会先存放在托管帐户中，直到课堂完成后才会发放给导师。你需要先支付 1 个月费用。如需取消或提出争议，你可在政策时限内为未使用课堂申请退款。',
  'howItWorksFaq.parent.4.question': '如果导师不适合，我可以退款吗？',
  'howItWorksFaq.parent.4.answer':
    '可以。如果你在第一堂课后不满意，可为未使用课堂申请退款，没有合约绑定。我们也鼓励你提供意见；如问题持续，我们的支援团队可协助你更换导师或处理退款。',
  'howItWorksFaq.parent.5.question': '你们接受哪些付款方式？',
  'howItWorksFaq.parent.5.answer':
    '我们接受马来西亚家长常用的银行转帐和 Touch n Go（TNG）。你只需在预约时选择合适方式即可。所有付款都会加密并安全处理，我们会使用可信赖的支付服务商保护你的财务资料。',
  'howItWorksFaq.parent.6.question': '所有导师都有验证吗？',
  'howItWorksFaq.parent.6.answer':
    '带有「Verified」标记的导师，均已提交身份证明文件并由我们核实。不过我们仍建议你在正式上课前先自行面谈和查核推荐资料。我们的验证只代表身份核实，不等同技能保证。',
  'howItWorksFaq.parent.7.question': '我可以为不同科目聘请多位导师吗？',
  'howItWorksFaq.parent.7.answer':
    '当然可以。你可以为不同科目发布多个个案，并聘请不同导师。每个个案都独立处理，你需要按个案付款、分开安排时间，也可以独立调整或取消，不会互相影响。',
  'howItWorksFaq.parent.8.question': '如果导师取消课堂怎么办？',
  'howItWorksFaq.parent.8.answer':
    '如果导师突然停止授课或无预警取消，请立即联络我们。我们会协助重新配对导师，或为未使用课堂安排退款。你的付款受保障，不会因导师取消而蒙受损失。',
  'howItWorksFaq.parent.9.question': '我如何与导师沟通？',
  'howItWorksFaq.parent.9.answer':
    '完成预约后，你可以透过平台直接向导师发讯息，或交换联络方式（WhatsApp、电邮、电话）。之后的排课、讨论内容和协调安排都可直接进行，平台不会介入日常沟通。',
  'howItWorksFaq.contact.description': '找不到你的答案？欢迎查看完整的',
  'howItWorksFaq.contact.helpCenter': '帮助中心',
  'howItWorksFaq.contact.suffix': '，或直接联络我们的支援团队。',
  'howItWorksFaq.contact.email': '电邮：tutorfounder@gmail.com',
  'paymentTimeline.tutor.title': '导师付款流程',
  'paymentTimeline.parent.title': '家长付款流程',
  'paymentTimeline.tutor.protection.title': '你的款项受到保障',
  'paymentTimeline.tutor.protection.1': '家长先付款，让你的收入更有保障。',
  'paymentTimeline.tutor.protection.2': '款项在月底前存放于托管系统中，更安全可靠。',
  'paymentTimeline.tutor.protection.3': '每月自动转帐，无需手动申请。',
  'paymentTimeline.tutor.protection.4': '若出现付款问题，你可在 7 天内提出争议。',
  'paymentTimeline.parent.refund.title': '退款更简单',
  'paymentTimeline.parent.refund.1': '未使用课堂可按政策申请退款。',
  'paymentTimeline.parent.refund.2': '没有绑约，也没有隐藏费用。',
  'paymentTimeline.parent.refund.3': '若导师中止教学，我们会协助重新配对或退款。',
  'paymentTimeline.parent.protection.title': '你的保障',
  'paymentTimeline.parent.protection.1': '所有导师都会先经身份文件验证。',
  'paymentTimeline.parent.protection.2': '若有问题，可在 7 天内提出争议。',
  'paymentTimeline.parent.protection.3': '款项会在你满意前存放于托管机制中。',
  'paymentTimeline.tutor.phase1.phase': '第 1 天',
  'paymentTimeline.tutor.phase1.title': '家长付款给平台',
  'paymentTimeline.tutor.phase1.description': '家长预约课堂并付款（先付 1 个月费用）。',
  'paymentTimeline.tutor.phase1.detail1': '银行转帐或 TNG',
  'paymentTimeline.tutor.phase1.detail2': '安全托管',
  'paymentTimeline.tutor.phase2.phase': '第 1-4 周',
  'paymentTimeline.tutor.phase2.title': '你进行授课',
  'paymentTimeline.tutor.phase2.description': '每周进行课堂。家长付款在托管中存放，保障双方。',
  'paymentTimeline.tutor.phase2.detail1': '时间安排灵活',
  'paymentTimeline.tutor.phase2.detail2': '可追踪授课时数',
  'paymentTimeline.tutor.phase2.detail3': '直接与家长协调',
  'paymentTimeline.tutor.phase3.phase': '月底',
  'paymentTimeline.tutor.phase3.title': '我们转帐给你',
  'paymentTimeline.tutor.phase3.description':
    '你应得的 75%（第 1-2 个月）或 100%（第 3 个月起）会转入你的银行户口。',
  'paymentTimeline.tutor.phase3.detail1': '自动转帐',
  'paymentTimeline.tutor.phase3.detail2': '转入你的登记银行户口',
  'paymentTimeline.tutor.phase3.detail3': '避免延误',
  'paymentTimeline.parent.phase1.phase': '第 1 天',
  'paymentTimeline.parent.phase1.title': '你先付款',
  'paymentTimeline.parent.phase1.description': '先为 1 个月课堂完成付款，并选择付款方式。',
  'paymentTimeline.parent.phase1.detail1': '银行转帐或 TNG',
  'paymentTimeline.parent.phase1.detail2': '加密安全',
  'paymentTimeline.parent.phase1.detail3': '先付 1 个月',
  'paymentTimeline.parent.phase2.phase': '付款进入托管',
  'paymentTimeline.parent.phase2.title': '款项受到保障',
  'paymentTimeline.parent.phase2.description': '你的付款会安全保存在托管中，直到课堂完成才会拨出。',
  'paymentTimeline.parent.phase2.detail1': '低风险安排',
  'paymentTimeline.parent.phase2.detail2': '可按政策退款',
  'paymentTimeline.parent.phase2.detail3': '保障你的权益',
  'paymentTimeline.parent.phase3.phase': '第 1-4 周',
  'paymentTimeline.parent.phase3.title': '开始上课',
  'paymentTimeline.parent.phase3.description': '与导师开始每周课堂，直接追踪学习进度。',
  'paymentTimeline.parent.phase3.detail1': '每周上课安排',
  'paymentTimeline.parent.phase3.detail2': '可直接沟通',
  'paymentTimeline.parent.phase3.detail3': '没有多余中间人',
  'paymentTimeline.parent.phase4.phase': '月底',
  'paymentTimeline.parent.phase4.title': '导师收到款项',
  'paymentTimeline.parent.phase4.description': '款项会拨给导师，你也会收到通知，再决定下月安排或退款。',
  'paymentTimeline.parent.phase4.detail1': '转帐透明',
  'paymentTimeline.parent.phase4.detail2': '你有 7 天可提出争议',
  'paymentTimeline.parent.phase4.detail3': '可安排下个月课程',
};
